module.exports = __webpack_public_path__ + "img/cs-icons-linkedin-filled.ce9746e0.svg";